import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassView from "./routes/ClassView/";
import StudentView from "./routes/StudentView";
export default store => ({
  path: ":yearGroupId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassView(store), StudentView(store)],
});
